import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals'
import { Sentry, isObservabilityEnabled } from '@/lib/observability/sentry'

function reportMetric(metric: Metric) {
  if (!isObservabilityEnabled()) return
  Sentry.captureMessage(`web-vital:${metric.name}`, {
    level: 'info',
    tags: {
      metric: metric.name,
      metric_id: metric.id,
    },
    extra: {
      value: metric.value,
      rating: metric.rating,
      delta: metric.delta,
      navigationType: metric.navigationType,
    },
  })
}

export function reportWebVitals() {
  onCLS(reportMetric)
  onINP(reportMetric)
  onLCP(reportMetric)
  onFCP(reportMetric)
  onTTFB(reportMetric)
}
